import { useEffect, useState } from "react";

/** Relógio que re-renderiza a cada `intervaloMs` (contadores de espera). */
export function useAgora(intervaloMs: number): number {
  const [agora, setAgora] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setAgora(Date.now()), intervaloMs);
    return () => clearInterval(t);
  }, [intervaloMs]);
  return agora;
}
